import { requests } from "../config";
import { IPostErrorData } from "./models/postError";

export const Logs = {
    getOrderLogsByOrderId: (orderId: number | string) => requests.get(`api/get-order/${orderId}`, 'mongo'),
    postError: (data: IPostErrorData) => requests.post('log/front_error', "go", data)
}